// extracted by mini-css-extract-plugin
module.exports = {"root":"bq_bx"};